import { useState } from "react";

const Input = ({label, value, placeholder, update}: {label: string, value: string | boolean | number, placeholder: string, update: (label: string, value: string | boolean | number) => void}) => {
    switch (typeof value) {
        case "string":
            return <><label>{label}</label><input type="text" value={value} placeholder={placeholder} onChange={(e) => update(label, e.target.value)} /></>;
        case "boolean":
            return <label>{label}<input type="checkbox" checked={value as boolean} onChange={(e) => update(label, e.target.checked)} /></label>;
        case "number":
            return <><label>{label}</label><input type="text" value={value} placeholder={placeholder} onChange={(e) => update(label, e.target.value)} /></>;
        default:
            return null;
    }
}

const FormModal = ({data, onCreate}: {data: {[x: string]: any}, onCreate: (data: {[x: string]: any}) => void}) => {
    const [formData, setFormData] = useState(data);
    const handleChange = (label: string, value: string | boolean | number) => {
        setFormData({...formData, [label]: value});
    };
    return (
        <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
            {Object.keys(formData).map((key) => (
                <Input key={key} label={key} value={formData[key]} placeholder={`Enter ${key}`} update={handleChange} />
            ))}
            <button className="btn" onClick={() => onCreate(formData)}><p>Add</p><i className="fa-solid fa-plus"></i></button>
        </div>
    );
}
export default FormModal;